import React, { useEffect, useState } from "react";
import { MeetingProvider } from "@videosdk.live/react-sdk";
import { MeetingAppProvider } from "./MeetingAppContextDef";
import { useParams } from "react-router-dom";
import { MeetingContainer } from "./meeting/MeetingContainer";
import { LeaveScreen } from "./components/screens/LeaveScreen";
import { JoiningScreen } from "./components/screens/JoiningScreen";

const VideoCall = () => {
  const [token, setToken] = useState("eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcGlrZXkiOiIwOWIzM2E1NS04MzVkLTRmMTUtOWVlNC04ZGYwNzgyZTgyYjIiLCJwZXJtaXNzaW9ucyI6WyJhbGxvd19qb2luIl0sImlhdCI6MTc2NzY3ODI0MSwiZXhwIjoxNzk5MjE0MjQxfQ.HeKanvIWv80OYZJy9mrkLD2rBEJsRB95O9OUXNKXhuM");
  const [meetingId, setMeetingId] = useState(null);
  const [participantName, setParticipantName] = useState("");
  const [micOn, setMicOn] = useState(true);
  const [webcamOn, setWebcamOn] = useState(true);
  const [isMeetingStarted, setMeetingStarted] = useState(false);
  const [isMeetingLeft, setIsMeetingLeft] = useState(false);
  const [customAudioStream, setCustomAudioStream] = useState(null);
  const [customVideoStream, setCustomVideoStream] = useState(null)


  let { id } = useParams();

  console.log(meetingId)

  const isMobile = window.matchMedia(
    "only screen and (max-width: 768px)"
  ).matches;

  useEffect(() => {
    if (isMobile) {
      window.onbeforeunload = () => {
        return "Are you sure you want to exit?";
      };
    }
  }, [isMobile]);

  useEffect(()=>{
    setMeetingId(id);
    setMeetingStarted(true);

    console.log('meetingId: ', id)
  },[id])

  return (
    // <>
    //   {isMeetingStarted ? (
    //     <MeetingAppProvider
    //       selectedMic={selectedMic}
    //       selectedWebcam={selectedWebcam}
    //       initialMicOn={micOn}
    //       initialWebcamOn={webcamOn}
    //     >
    //       <MeetingProvider
    //         config={{
    //           meetingId,
    //           micEnabled: micOn,
    //           webcamEnabled: webcamOn,
    //           name: participantName ? participantName : "TestUser",
    //           mode: meetingMode,
    //           multiStream: false,
    //         }}
    //         token={token}
    //         reinitialiseMeetingOnConfigChange={true}
    //         joinWithoutUserInteraction={true}
    //       >
    //         <ILSContainer
    //           onMeetingLeave={() => {
    //             setToken("");
    //             setMeetingId("");
    //             setParticipantName("");
    //             setWebcamOn(false);
    //             setMicOn(false);
    //             setMeetingStarted(false);
    //           }}
    //           setIsMeetingLeft={setIsMeetingLeft}
    //           selectedMic={selectedMic}
    //           selectedWebcam={selectedWebcam}
    //           selectWebcamDeviceId={selectWebcamDeviceId}
    //           setSelectWebcamDeviceId={setSelectWebcamDeviceId}
    //           selectMicDeviceId={selectMicDeviceId}
    //           setSelectMicDeviceId={setSelectMicDeviceId}
    //           micEnabled={micOn}
    //           webcamEnabled={webcamOn}
    //           meetingMode={meetingMode}
    //           setMeetingMode={setMeetingMode}
    //         />
    //       </MeetingProvider>
    //     </MeetingAppProvider>
    //   ) : isMeetingLeft ? (
    //     <LeaveScreen setIsMeetingLeft={setIsMeetingLeft} />
    //   ) : (
    //     <JoiningScreen
    //       participantName={participantName}
    //       setParticipantName={setParticipantName}
    //       setMeetingId={setMeetingId}
    //       setToken={setToken}
    //       setMicOn={setMicOn}
    //       micEnabled={micOn}
    //       webcamEnabled={webcamOn}
    //       setSelectedMic={setSelectedMic}
    //       setSelectedWebcam={setSelectedWebcam}
    //       setWebcamOn={setWebcamOn}
    //       onClickStartMeeting={() => {
    //         setMeetingStarted(true);
    //       }}
    //       startMeeting={isMeetingStarted}
    //       setIsMeetingLeft={setIsMeetingLeft}
    //       meetingMode={meetingMode}
    //       setMeetingMode={setMeetingMode}
    //     />
    //   )}
    // </>
    <>
    {meetingId &&  <MeetingAppProvider>
            {isMeetingStarted ? (
    
              <MeetingProvider
                config={{
                  meetingId,
                  micEnabled: micOn,
                  webcamEnabled: webcamOn,
                  name: participantName ? participantName : "TestUser",
                  multiStream: true,
                  customCameraVideoTrack: customVideoStream,
                  customMicrophoneAudioTrack: customAudioStream
                }}
                token={token}
                reinitialiseMeetingOnConfigChange={true}
                joinWithoutUserInteraction={true}
              >
                <MeetingContainer
                  onMeetingLeave={() => {
                    setToken("");
                    setMeetingId("");
                    setParticipantName("");
                    setWebcamOn(false);
                    setMicOn(false);
                    setMeetingStarted(false);
                  }}
                  setIsMeetingLeft={setIsMeetingLeft}
                />
              </MeetingProvider>
    
            ) : isMeetingLeft ? (
              <LeaveScreen setIsMeetingLeft={setIsMeetingLeft} />
            ) : (
    
              <JoiningScreen
                participantName={participantName}
                setParticipantName={setParticipantName}
                setMeetingId={setMeetingId}
                setToken={setToken}
                micOn={micOn}
                setMicOn={setMicOn}
                webcamOn={webcamOn}
                setWebcamOn={setWebcamOn}
                customAudioStream={customAudioStream}
                setCustomAudioStream={setCustomAudioStream}
                customVideoStream={customVideoStream}
                setCustomVideoStream={setCustomVideoStream}
                onClickStartMeeting={() => {
                  setMeetingStarted(true);
                }}
                startMeeting={isMeetingStarted}
                setIsMeetingLeft={setIsMeetingLeft}
              />
            )}
          </MeetingAppProvider>}
    </>
  );
};

export default VideoCall;
